export default "__VITE_ASSET__DS2AX1Iq__"